import { useCallback, type ReactNode } from 'react';
import { RecaptchaNotice } from '@/components/RecaptchaNotice';
import { SCROLL_DETAILS_FORM } from '@/consts/events';
import { WregPhase } from '../WregPhase';
import { WREG_STEP_NAME, wregStepNumber, type WregStep } from '../wregSteps';
import {
  useWregScrollDirection,
  type WregScreenEvent,
  type WregScrollDirection,
} from './wregScreenEvents';

type Props = {
  step: WregStep;
  title: string;
  sub?: string;
  notice?: string | null;
  onEvent?: WregScreenEvent;
  children: ReactNode;
  footer: ReactNode;
  overlay?: ReactNode;
};

const WregIntakeShell = ({
  step,
  title,
  sub,
  notice,
  onEvent,
  children,
  footer,
  overlay,
}: Props) => {
  const onScrollDirection = useCallback(
    (direction: WregScrollDirection) =>
      onEvent?.(SCROLL_DETAILS_FORM, { direction, step_name: WREG_STEP_NAME[step] }),
    [onEvent, step],
  );
  const trackScroll = useWregScrollDirection(onScrollDirection);

  return (
    <div className="rg-screen wreg-intake-screen">
      <div className="rg-body-wrap">
        <div className="rg-body" onScroll={(e) => trackScroll(e.currentTarget)}>
          <div className="rg-inner">
            <div className="rg-head-block">
              <WregPhase n={wregStepNumber(step)} />
              <h1 className="rg-h1">{title}</h1>
              {sub && <p className="rg-sub">{sub}</p>}
            </div>
            {notice && (
              <div className="rg-disclosure" style={{ background: 'var(--hh-gold-4, #F6E3C9)' }}>
                <span className="ic" aria-hidden="true">i</span>
                <p>{notice}</p>
              </div>
            )}
            {children}
          </div>
        </div>
      </div>
      <div className="rg-foot">
        <div className="wreg-foot-row">{footer}</div>
        <div className="wreg-foot-legal">
          <RecaptchaNotice />
        </div>
      </div>
      {overlay}
    </div>
  );
};

export { WregIntakeShell };
